import { render } from "./TicketSessions.vue?vue&type=template&id=87f0efa8"
import script from "./TicketSessions.vue?vue&type=script&lang=js"
export * from "./TicketSessions.vue?vue&type=script&lang=js"

import "./TicketSessions.vue?vue&type=style&index=0&id=87f0efa8&lang=scss"

import exportComponent from "/Users/patricksantner/projects/alpbach-ticketshop-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__